import {connect} from "react-redux";
import SignUpWithMail from "./SignUpWithMail";
import {checkUserExist, signUp} from "../../../globalState/user/actions";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../../HOC/WithAppendHeaderAndFooterHOC";


let mapStateToProps = (state) => {
    return {
        userIsAuth: state.user.userIsAuth
    }
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
    signUp,
    checkUserExist
}), WithAppendHeaderAndFooterHOC)(SignUpWithMail);



